import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import { SortMenu } from "~/components/SortButtons/SortMenu";
import { SORT_BUTTON } from "~/constants/testIDs";
export const ViewSortingMenuComponent = /*#__PURE__*/ memo((param)=>{
    let { currentlySortedBy, onChange, sortDirection, availableSortOptions } = param;
    return /*#__PURE__*/ _jsx(SortMenu, {
        "data-testid": SORT_BUTTON,
        currentSortBy: currentlySortedBy,
        sortOptions: availableSortOptions,
        onSortChange: onChange,
        direction: sortDirection
    });
});
ViewSortingMenuComponent.displayName = "ViewSortingMenuComponent";
